import React from "react";
import Navbar from "../../components/navbar";
import AdminMenu from "../../components/admin/adminMenu";
import Footer from "../../components/footer";
import TramiteMessageConfig from "../../components/admin/tramiteMessage";
import PasswordChangeForm from "../../components/admin/passwordChangeForm";
import InstanceConfigurationForm from "../../components/admin/instanceConfigurationForm";
import LogoUploaderForm from "../../components/admin/logoUploaderForm";
import LocalStorageService from "../../ports/localStorage/localStorageService";

export default class Configuration extends React.Component {
    componentDidMount() {
        const token = LocalStorageService.getUserToken();
        if (!token) {
            window.location.assign("/admin");
        }
    }
    render() {

        return(
            <div id="layout-wrapper">
                <Navbar />
                <AdminMenu />

                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">

                                <div className="col-6">
                                    <div className="page-title-box d-flex align-items-center justify-content-between">
                                        <h4 className="mb-0 font-size-18" style={{color: "#ffff"}}>Configuración del sistema</h4>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-xl-6">
                                    <PasswordChangeForm />
                                </div>
                                <div className="col-xl-6">
                                    <InstanceConfigurationForm />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <LogoUploaderForm />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <TramiteMessageConfig tramite="dni" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <TramiteMessageConfig tramite="passport" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}